import MessageWarn from "./searchope.vue"

const Situationall = {
	install(Vue) {//install方法注册全局组件
		Vue.component('Situationall', MessageWarn)
	}
};

export default Situationall;
